


























































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SkuSidebar from '../components/skuSidebar.vue';
import tableEmpty from '@/components/empty/tableEmpty.vue';

import {
  goodsListPagination,
  findBrandsList,
  batchPublish,
  batchCancelPublish,
  delGoods,
  queryList,
  goodsDetail,
  batchDelGoods,
  batchSearchCancelPublish,
  batchSearchPublish,
} from '@/utils/api';
@Component({
  components: { SkuSidebar, tableEmpty },
})
export default class goodsManage extends Vue {
  $bus: any;
  articless: number = 10;
  $refs: any;
  cascaderOptions: object = {
    // 级联选择器配置
    expandTrigger: 'hover',
    label: 'name',
    value: 'id',
    children: 'childs',
    checkStrictly: true,
  };
  activeName: string = '0';
  // 表单数据
  formInline: object = {
    page: 0,
    size: 10,
    tmpSave: 0,
    type: '0',
  };
  sex: Number = 0;
  age: Number = 0;
  formInline1: object = {
    page: 0,
    size: 10,
    tmpSave: 0,
    published: 1,
    type: '1',
  };
  formInline2: object = {
    page: 0,
    size: 10,
    tmpSave: 0,
    published: 0,
    type: '2',
  };
  formInline3: object = {
    page: 0,
    size: 10,
    tmpSave: 1,
    type: '3',
  };
  total: Number = 0;
  region: any = []; //品牌数据
  list: any = []; //类目数据
  // 表格数据
  tableData: any = [];
  multipleSelection: any = [];
  //sku侧边栏数据
  skuData: boolean = false;
  skuList: any = {};
  //删除数据
  arr: any = [];
  loading: boolean = true;
  checkAll: boolean = false;
  isIndeterminate: boolean = true;
  requestMap: object = { '0': [], '1': [], '2': [], '3': [] };



  commodityCategory: string = 'spuIdOrSkuId';//商品类别
  commodityCategoryVal: string = '';//商品类别的值
  commodityCategoryList: Array<string> = [];//商品类别的数组值
  supplierNumber: string = 'spuCodeOrSkuCode';//供应商编号类别
  supplierNumberVal: string = '';//供应商编号类别值
  supplierNumberList: Array<string> = [];//供应商编号数组值
  /* 商品类别切换 */
  commodityCategoryChange(val){
    console.log(val);
    this.commodityCategoryVal = '';
    this.commodityCategoryList = [];
  }
  /* 供应商编号类别切换 */
  supplierNumberChange(val){
    this.supplierNumberVal = '';
    this.supplierNumberList = [];
  }

  /* 商品类别转化为数组 */
  commodityCategoryConversion(value){
    let data = value.replace(/(^\s*)|(\s*$)/g, "");
    if(data == ''){
      this.commodityCategoryVal = '';
      this.commodityCategoryList = [];
    }else{
      let val = data.split(/\s+/);
      if(val.length <= 100){
        this.commodityCategoryList = val;
      }else{
        this.commodityCategoryVal = (val.slice(0,100)).join(' ');
      }
    }
  }
  /* 供应商货号转数组 */
  supplierNumberConversion(value){
    let data = value.replace(/(^\s*)|(\s*$)/g, "");
    if(data == ''){
      this.supplierNumberVal = '';
      this.supplierNumberList = [];
    }else{
      let val = data.split(/\s+/);
      if(val.length <= 100){
        this.supplierNumberList = val;
      }else{
        this.supplierNumberVal = (val.slice(0,100)).join(' ');
      }
    }
  }

  @Watch('activeName', { deep: true })
  valuechange(newValue, oldValue) {
    this.resetForm();//重置数据
    this.query();
  }
  created() {}
  mounted() {
    // 查询所有商品列表
    this.goodsList();
    // 查询品牌
    findBrandsList().then((res: any) => {
      this.region = res;
    });
    // 查询商品类目
    queryList().then((data: any) => {
      this.list = data;
    });
  }
  // 保存更新表格
  goodsmanage(val) {
    this.query();
  }
  // 查询所有商品列表
  goodsList() {
    document.querySelector('html').scrollTop = 0; //先滚动到顶部再加载，以保证loading效果和滚动体验
    this.loading = true;
    let formParams = null;

    switch (this.activeName) {
      case '0':
        formParams = this.formInline;
        break;
      case '1':
        formParams = this.formInline1;
        break;
      case '2':
        formParams = this.formInline2;
        break;
      case '3':
        formParams = this.formInline3;
        break;
    }
    let commodityCategory = this.commodityCategory;
    let supplierNumber = this.supplierNumber;
    let datas = {
      ...formParams
    }
    if(commodityCategory == 'spuIdOrSkuId'){
      datas[commodityCategory] = this.commodityCategoryVal;
    }else{
      datas[commodityCategory] = this.commodityCategoryList;
    }
    if(supplierNumber =='spuCodeOrSkuCode'){
      datas[supplierNumber] = this.supplierNumberVal;
    }else{
      datas[supplierNumber] = this.supplierNumberList;
    }
    goodsListPagination(datas)
      .then((res: any) => {
        this.tableData = res.data.content;
        this.tableData.forEach((item, i) => {
          this.tableData[i].lowestCostPrice = Number(item.lowestCostPrice).toFixed(2);
        });
        const $table = this.$refs.xTable1;
        if ($table) {
          $table.loadData(this.tableData);
        }

        //start  此处逻辑是：每次获取到数据的时候，记录这个数据数组到对应的tab组里，然后在页面中展示当前tab的table数据，防止快速切换后网络因素导致数据展示混乱不是当前tab的情况
        this.requestMap[JSON.parse(res.config.data).type] = this.tableData;
        //end
        this.loading = false;
        this.total = res.data.totalElements;
        this.sex = this.tableData.length;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  // 选择时间
  changetime(value) {
    if (this.activeName == '0') {
      this.formInline['createBeginTime'] = value[0];
      this.formInline['createEndTime'] = value[1];
    } else if (this.activeName == '3') {
      this.formInline3['createBeginTime'] = value[0];
      this.formInline3['createEndTime'] = value[1];
    } else if (this.activeName == '1') {
      this.formInline1['createBeginTime'] = value[0];
      this.formInline1['createEndTime'] = value[1];
    } else if (this.activeName == '2') {
      this.formInline2['createBeginTime'] = value[0];
      this.formInline2['createEndTime'] = value[1];
    }
  }
  // 选择商品类目ID
  classifyChange(value) {
    if (this.activeName == '0') {
      this.formInline['levelOneClassifyId'] = value[0];
      this.formInline['levelThrClassifyId'] = value[2] || '';
      this.formInline['levelTwoClassifyId'] = value[1] || '';
    } else if (this.activeName == '3') {
      this.formInline3['levelOneClassifyId'] = value[0];
      this.formInline3['levelThrClassifyId'] = value[2] || '';
      this.formInline3['levelTwoClassifyId'] = value[1] || '';
    } else if (this.activeName == '1') {
      this.formInline1['levelOneClassifyId'] = value[0];
      this.formInline1['levelThrClassifyId'] = value[2] || '';
      this.formInline1['levelTwoClassifyId'] = value[1] || '';
    } else if (this.activeName == '2') {
      this.formInline2['levelOneClassifyId'] = value[0];
      this.formInline2['levelThrClassifyId'] = value[2] || '';
      this.formInline2['levelTwoClassifyId'] = value[1] || '';
    }
  }
  // 编辑
  edit(spuId) {
    this.$router.push({ path: '/goods/goodsEdit/goodsEdit', query: { spuid: spuId } });
  }
  /* 复制商品数据 */
  copyData(spuId){
    this.$router.push({ path: '/goods/goodsEdit/goodsEdit', query: { spuid: spuId, copy: 'copy' } });
  }
  // 单个上架下架删除
  operation(e, value) {
    if (this.activeName != '3') {
      var a = [];
      a.push(value);
      if (e == 0) {
        this.loading = true;
        batchPublish({ spuIds: a })
          .then((res: any) => {
            this.$message({
              message: `操作成功`,
              type: 'success',
            });
            this.goodsList();
          })
          .catch(() => {
            this.loading = false;
          });
      } else if (e == 1) {
        this.loading = true;
        batchCancelPublish({ spuIds: a })
          .then((res: any) => {
            this.$message({
              message: `操作成功`,
              type: 'success',
            });
            this.goodsList();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    } else if (this.activeName == '3') {
      var obj = {
        spuId: value || this.multipleSelection[0],
      };
      this.loading = true;
      delGoods(obj)
        .then((res: any) => {
          this.$message({
            message: `操作成功`,
            type: 'success',
          });
          this.goodsList();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
  // 上架售卖
  release(e) {
    this.$confirm('确定执行上架售卖操作?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      if (e == 2) {
        if (this.multipleSelection.length < 1) {
          this.$message.warning('请选择商品！');
          return;
        }
        // 已选择 上架
        this.loading = true;
        batchPublish({ spuIds: this.multipleSelection })
          .then((res: any) => {
            this.$message({
              message: `操作成功`,
              type: 'success',
            });
            this.goodsList();
          })
          .catch(() => {
            this.loading = false;
          });
      } else if (e == 1) {
        //批量筛选上架
        if (this.activeName == '0') {
          this.loading = true;
          let commodityCategory = this.commodityCategory;
          let supplierNumber = this.supplierNumber;
          let datas = {
            ...this.formInline
          }
          if(commodityCategory == 'spuIdOrSkuId'){
            datas[commodityCategory] = this.commodityCategoryVal;
          }else{
            datas[commodityCategory] = this.commodityCategoryList;
          }
          if(supplierNumber =='spuCodeOrSkuCode'){
            datas[supplierNumber] = this.supplierNumberVal;
          }else{
            datas[supplierNumber] = this.supplierNumberList;
          }
          batchSearchPublish(datas)
            .then((res: any) => {
              this.$message({
                message: `操作成功`,
                type: 'success',
              });
              this.$bus.$emit('openTask');
              this.goodsList();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.loading = true;
          let commodityCategory = this.commodityCategory;
          let supplierNumber = this.supplierNumber;
          let datas = {
            ...this.formInline2
          }
          if(commodityCategory == 'spuIdOrSkuId'){
            datas[commodityCategory] = this.commodityCategoryVal;
          }else{
            datas[commodityCategory] = this.commodityCategoryList;
          }
          if(supplierNumber =='spuCodeOrSkuCode'){
            datas[supplierNumber] = this.supplierNumberVal;
          }else{
            datas[supplierNumber] = this.supplierNumberList;
          }
          batchSearchPublish(datas)
            .then((res: any) => {
              this.$message({
                message: `操作成功`,
                type: 'success',
              });
              this.$bus.$emit('openTask');
              this.goodsList();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      }
    });
  }
  //下架停售
  commodityExport(e) {
    this.$confirm('确定执行下架停售操作?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      if (e == 1) {
        //批量筛选下架
        if (this.activeName == '0') {
          this.loading = true;
          let commodityCategory = this.commodityCategory;
          let supplierNumber = this.supplierNumber;
          let datas = {
            ...this.formInline
          }
          if(commodityCategory == 'spuIdOrSkuId'){
            datas[commodityCategory] = this.commodityCategoryVal;
          }else{
            datas[commodityCategory] = this.commodityCategoryList;
          }
          if(supplierNumber =='spuCodeOrSkuCode'){
            datas[supplierNumber] = this.supplierNumberVal;
          }else{
            datas[supplierNumber] = this.supplierNumberList;
          }
          batchSearchCancelPublish(datas)
            .then((res: any) => {
              this.$message({
                message: `操作成功`,
                type: 'success',
              });
              this.$bus.$emit('openTask');
              this.goodsList();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.loading = true;
          let commodityCategory = this.commodityCategory;
          let supplierNumber = this.supplierNumber;
          let datas = {
            ...this.formInline1
          }
          if(commodityCategory == 'spuIdOrSkuId'){
            datas[commodityCategory] = this.commodityCategoryVal;
          }else{
            datas[commodityCategory] = this.commodityCategoryList;
          }
          if(supplierNumber =='spuCodeOrSkuCode'){
            datas[supplierNumber] = this.supplierNumberVal;
          }else{
            datas[supplierNumber] = this.supplierNumberList;
          }
          batchSearchCancelPublish(datas)
            .then((res: any) => {
              this.$message({
                message: `操作成功`,
                type: 'success',
              });
              this.$bus.$emit('openTask');
              this.goodsList();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      } else if (e == 2) {
        if (this.multipleSelection.length < 1) {
          this.$message.warning('请选择商品！');
          return;
        }
        // 已选择 下架
        this.loading = true;
        batchCancelPublish({ spuIds: this.multipleSelection })
          .then((res: any) => {
            this.$message({
              message: `操作成功`,
              type: 'success',
            });
            this.goodsList();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    });
  }

  // 批量删除
  batchDelete(e) {
    var a = [];
    this.arr.forEach((item) => {
      // a.push(Number(item.spuId));
      a.push(item['spuId']);
    });
    this.loading = true;
    batchDelGoods({ spuIds: a })
      .then((res: any) => {
        this.$message({
          message: `操作成功`,
          type: 'success',
        });
        this.goodsList();
      })
      .catch(() => {
        this.loading = false;
      });
  }
  // 查询
  query() {
    this.age = 0;
    this.formInline['page'] = 0;
    this.formInline1['page'] = 0;
    this.formInline2['page'] = 0;
    this.formInline3['page'] = 0;
    document.querySelector('html').scrollTop = 0; //先滚动到顶部再加载，以保证loading效果和滚动体验
    this.goodsList();
  }
  // sku侧边栏
  skuc(e) {
    goodsDetail(e).then((res: any) => {
      this.skuList = res;
      this.skuData = true;
      this.$refs['skuSidebar'].openDrawer();
    });
  }
  // 分页事件
  handleSizeChange(val) {
    this.formInline['size'] = val;
    this.formInline1['size'] = val;
    this.formInline2['size'] = val;
    this.formInline3['size'] = val;
    this.query();
  }
  handleCurrentChange(val) {
    this.formInline['page'] = val - 1;
    this.formInline1['page'] = val - 1;
    this.formInline2['page'] = val - 1;
    this.formInline3['page'] = val - 1;
    this.goodsList();
  }
  // 重置
  resetForm() {
    if (this.activeName == '0') {
      this.formInline = {};
      this.formInline = {
        page: 0,
        size: this.articless,
        tmpSave: 0,
      };
    } else if (this.activeName == '3') {
      this.formInline3 = {};
      this.formInline3 = {
        page: 0,
        size: this.articless,
        tmpSave: 1,
      };
    } else if (this.activeName == '1') {
      this.formInline1 = {};
      this.formInline1 = {
        page: 0,
        size: this.articless,
        tmpSave: 0,
        published: 1,
      };
    } else if (this.activeName == '2') {
      this.formInline2 = {};
      this.formInline2 = {
        page: 0,
        size: this.articless,
        tmpSave: 0,
        published: 0,
      };
    }
    this.multipleSelection = [];
    this.commodityCategory = 'spuIdOrSkuId';//商品类别
    this.commodityCategoryVal = '';//商品类别的值
    this.commodityCategoryList = [];//商品类别的数组值
    this.supplierNumber = 'spuCodeOrSkuCode';//供应商编号类别
    this.supplierNumberVal = '';//供应商编号类别值
    this.supplierNumberList = [];//供应商编号数组值
  }
  // 表格选中事件
  handleSelectionChange() {
    let selectRecords = this.$refs.xTable1.getCheckboxRecords();
    if (selectRecords.length > 0) {
      this.$message.success('选择了' + selectRecords.length + '个商品');
    }
    this.arr = selectRecords;
    this.multipleSelection = [];
    selectRecords.forEach((item) => {
      this.multipleSelection.push(item.spuId);
    });
  }

  //点击tabs, 清除信息
  tabClick() {
    this.arr = [];
    this.multipleSelection = [];
  }
}
